import React from 'react';
import { CONSTANTS } from '../../data';

interface ChatModalProps {
  chatMessages: Array<{text: string, sender: 'user' | 'ai'}>;
  setChatMessages: React.Dispatch<React.SetStateAction<Array<{text: string, sender: 'user' | 'ai'}>>>;
  chatInput: string;
  setChatInput: React.Dispatch<React.SetStateAction<string>>;
  isAiTyping: boolean;
  setIsAiTyping: React.Dispatch<React.SetStateAction<boolean>>;
  onClose: () => void;
  onSendMessage: () => void;
  onChatKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const ChatModal: React.FC<ChatModalProps> = ({
  chatMessages,
  chatInput,
  setChatInput,
  isAiTyping,
  onClose,
  onSendMessage,
  onChatKeyPress
}) => {
  return (
    <div id={CONSTANTS.TEST_AI.modalId} className="chat-modal-overlay">
      <div className="chat-modal">
        <div className="chat-modal-header">
          <h3>{CONSTANTS.TEST_AI.modalTitle}</h3>
          <button 
            className="chat-close-btn"
            onClick={onClose}
          >
            {CONSTANTS.TEST_AI.closeButtonText}
          </button>
        </div>
        <div id={CONSTANTS.TEST_AI.chatMessagesId} className="chat-messages">
          {chatMessages.map((msg, index) => (
            <div key={index} className={`chat-message ${msg.sender}`}>
              <span className="chat-sender">{msg.sender === 'user' ? 'You' : 'AI'}:</span>
              <span className="chat-text">{msg.text}</span>
            </div>
          ))}
          {isAiTyping && (
            <div className="chat-message ai">
              <span className="chat-sender">AI:</span>
              <span className="chat-text typing-indicator">
                {CONSTANTS.CHAT.typingIndicatorText}
                <span className="typing-dots">
                  <span>.</span>
                  <span>.</span>
                  <span>.</span>
                </span>
              </span>
            </div>
          )}
        </div>
        <div className="chat-input-area">
          <input
            id={CONSTANTS.TEST_AI.chatInputId}
            type="text"
            value={chatInput}
            onChange={(e) => setChatInput(e.target.value)}
            onKeyPress={onChatKeyPress}
            placeholder={CONSTANTS.TEST_AI.placeholderText}
            className="chat-input"
            disabled={isAiTyping}
          />
          <button 
            onClick={onSendMessage}
            className="chat-send-btn"
            disabled={isAiTyping || !chatInput.trim()}
          >
            {CONSTANTS.TEST_AI.sendButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
